<template>
  <div class="department_set">
    <div class="nav">{{ userInfo.entName }}</div>
    <div class="add-group">
      <!-- to="/lishui/departmentEdit" -->
      <van-cell @click="addDepartment">
        <template #title>
          <div class="cell-add">
            <van-icon name="add-o" />
            <span class="custom-title">新增部门</span>
          </div>
        </template>
      </van-cell>
    </div>
    <div class="user_list">
      <div
        class="user_li"
        v-for="(item, index) in deparList.orgList"
        :key="index"
      >
        {{ item.orgName }} ({{ item.orgNumber || '0' }})
        <span @click="subordinate(item.id, item.orgName, item.entName)">
          <van-icon size="20" name="cluster-o" />
          下级
        </span>
      </div>
      <div
        class="user-name"
        v-for="(items, i) in deparList.notInOrgList"
        :key="'info2-' + i"
      >
        <img src="../../../../assets/images/lishui-user.png" alt="" />
        <span>{{ items.staffName }}</span>
      </div>
      <!-- <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(item, index) in departmentList"
          :title="item.type"
          :key="index"
          :name="index + ''"
        >
          <template #title>
            <div class="user_header">
              {{ item.type }}
              <span>
                <van-icon size="20" name="cluster-o" />
                下级
              </span>
            </div>
          </template>
          <div
            class="office-list"
            v-for="(items, level) in item.departInfoVos"
            :key="level"
            @click="detailse()"
          >
            <div class="user-name">
              <img src="../../../../assets/images/lishui-user.png" alt="" />
              <span>{{ items.user }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse> -->
    </div>
    <van-dialog
      width="300"
      v-model="isShow"
      title="请输入部门名称"
      show-cancel-button
      class="department_name"
      :before-close="beforeCloses"
    >
      <input v-model="popupTxt" type="text" placeholder="请输入部门名称" />
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { lists, insertOrUpdate } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  data() {
    return {
      popupTxt: '',
      isShow: false,
      departmentList: [
        {
          type: '县市级机关政府1',
          departInfoVos: [
            {
              user: '姓名1'
            },
            {
              user: '姓名2'
            },
            {
              user: '姓名3'
            },
            {
              user: '姓名4'
            },
            {
              user: '姓名5'
            }
          ]
        },
        {
          type: '县市级机关政府2',
          departInfoVos: [
            {
              user: '姓名1'
            },
            {
              user: '姓名2'
            },
            {
              user: '姓名3'
            },
            {
              user: '姓名4'
            },
            {
              user: '姓名5'
            }
          ]
        },
        {
          type: '县市级机关政府3',
          departInfoVos: [
            {
              user: '姓名1'
            },
            {
              user: '姓名2'
            },
            {
              user: '姓名3'
            },
            {
              user: '姓名4'
            },
            {
              user: '姓名5'
            }
          ]
        }
      ],
      activeName: 1,
      deparList: {},
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  mounted() {
    this.departList()
  },
  methods: {
    addDepartment() {
      this.isShow = true
    },
    beforeCloses(action, done) {
      if (action === 'confirm') {
        if (this.popupTxt === '') {
          this.$notify('请输入部门名称')
          return done(false)
        } else {
          let par = {
            orgName: this.popupTxt,
            creditCode: this.userInfo.creditCode,
            entName: this.userInfo.entName
          }
          insertOrUpdate(par).then(res => {
            this.$notify({
              type: 'success',
              message: res.data.msg
            })
            this.departList()
          })
          return done()
        }
      } else {
        return done()
      }
    },
    // 部门列表
    departList() {
      let par = {
        creditCode: this.userInfo.creditCode
      }
      lists(par).then(res => {
        const { data, code } = res.data
        if (code === '0000') {
          this.deparList = data
        }
      })
    },
    subordinate(e, name, a) {
      this.$router.push({
        name: 'departmentEdit',
        query: { id: e, name: name, entName: a }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.department_set {
  /deep/.van-dialog__confirm {
    color: #0091ff;
  }
  .department_name {
    text-align: center;
    input {
      width: 80%;
      padding: 5px;
      height: 30px;
      margin: 20px auto 30px;
      border: 1px solid rgba($color: #999, $alpha: 0.4);
      border-radius: 2px;
    }
  }
  .nav {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding-left: 20px;
    border-bottom: 10px solid rgba($color: #999, $alpha: 0.1);
  }
  .add-group {
    // margin: 8px 0 0;
    border-bottom: 10px solid rgba($color: #999, $alpha: 0.1);
  }
  ::v-deep .van-cell {
    &__title {
      .cell-add {
        display: flex;
        align-items: center;
        color: #0091ff;
        i {
          margin-right: 5px;
        }
      }
    }
  }

  .user_list {
    // /deep/.van-collapse-item__content {
    //   color: #333 !important;
    //   padding: 0;
    // }
    // /deep/.van-cell__title {
    //   font-size: 16px;
    // }
    // /deep/.van-cell::after {
    //   border-bottom: none;
    // }
    // /deep/.van-cell {
    //   border-bottom: 2px solid rgba($color: #999, $alpha: 0.1);
    // }
    // /deep/.van-cell__right-icon {
    //   display: none;
    // }
    .user-name {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      border-bottom: 2px solid rgba($color: #999, $alpha: 0.1);
      padding-left: 16px;
      img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        margin-top: 8px;
        margin: 0 0 0 15px;
      }
    }
    .user_li {
      display: flex;
      justify-content: space-between;
      font-size: 17px;
      padding: 10px 20px;
      border-bottom: 2px solid rgba($color: #999, $alpha: 0.1);
      span {
        display: inline-block;
        padding-left: 10px;
        border-left: 1px solid rgba($color: #999, $alpha: 0.1);
        font-size: 16px;
        color: #0091ff;
        i {
          vertical-align: middle;
        }
      }
    }
  }
  .office-list {
  }
}
</style>
